import dayjs from "dayjs";
import { useState } from "react";

/** Ячейка таблицы предварительной записи */
const RecordsLineUser = ({ user, height, width, position, grafs, start, finish, onSelect, vid }) => {
  const [mousePosition, setMousePosition] = useState(null);

  const handleMouseMove = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const y = event.clientY - rect.top;
    const relativePosition = y / height; // от 0 до 1
    const discreteStep = Math.floor(relativePosition * 4); // 0, 1, 2, 3
    const discretePosition = Math.min(discreteStep, 3) * 0.25; // 0%, 25%, 50%, 75%    
    setMousePosition(discretePosition);
  };

  const handleMouseLeave = () => {
    setMousePosition(null);
  };

  const divGrafs = grafs
    .filter(g => g.calendarId === user.calendarId)
    .map(i => <div className="record-line-user-graf" key={i.id} 
      style={{top: (i.startMin < start  ? 0 : (i.startMin - start)) / 60 * height, bottom: (i.finishMin > finish ? 0 : (finish - i.finishMin)) / 60 * height }} 
      onClick={(event) => {
        const rect = event.currentTarget.parentElement.getBoundingClientRect();
        const y = event.clientY - rect.top;
        const relativePosition = y / height;
        const discreteStep = Math.floor(relativePosition * 4);
        const discretePositionPercent = Math.min(discreteStep, 3) * 25;      
        const addMinutes = discretePositionPercent/100*60;        
        onSelect({
          userId: vid === 0 ? user.id : null,
          roomId: vid === 1 ? user.id : null,
          start: dayjs().startOf('day').add(Math.max(start + addMinutes, i.startMin), 'minute'),
          finish: dayjs().startOf('day').add(Math.min(finish + addMinutes, i.finishMin), 'minute'),
        });
      }}/>)

  return<div 
    style={{width, height}} 
    className="records-line-user"
    onMouseMove={handleMouseMove}
    onMouseLeave={handleMouseLeave}
  >
    {position !== null && <div className="records-line-user-today" style={{top: position}}/>}
    {divGrafs}
    <div className="records-line-user-dashed-line"></div>
    {mousePosition !== null && (
      <div 
        className="records-line-user-cursor-indicator"
        style={{
          position: 'absolute',
          top: `${mousePosition * 100}%`,
          left: 0,
          width: '100%',
          height: '25%',
          backgroundColor: 'transparent',
          border: '1px solid red',
          borderRadius: '4px',
          pointerEvents: 'none',
          zIndex: 10
        }}
      />
    )}
  </div>
}

export default RecordsLineUser;